import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import communityMetaDataFragment from '../../fragments/community/communityMetaData';

import communityInfoFragment from '../../fragments/community/communityInfo';

import communityMembersFragment from '../../fragments/community/communityMembers';

const LoadMoreMembers = gql`
  query loadMoreCommunityMembers(
    $id: ID
    $after: String
    $first: Int
    $filter: MembersFilter
  ) {
    community(id: $id) {
      ...communityInfo
      ...communityMetaData
      ...communityMembers
    }
  }
  ${communityInfoFragment}
  ${communityMetaDataFragment}
  ${communityMembersFragment}
`;

export const getcommunityMembersQuery = gql`
  query getCommunityMembers(
    $id: ID
    $after: String
    $first: Int
    $filter: MembersFilter
  ) {
    community(id: $id) {
      ...communityInfo
      ...communityMetaData
      ...communityMembers
    }
  }
  ${communityInfoFragment}
  ${communityMetaDataFragment}
  ${communityMembersFragment}
`;

const getcommunityMembersOptions = {
  props: ({
    data: { fetchMore, error, loading, community, networkStatus },
    ownProps: { filter, sort },
  }) => ({
    data: {
      error,
      loading,
      community,
      networkStatus: networkStatus,
      hasNextPage:
        community && community.members
          ? community.members.pageInfo.hasNextPage
          : false,
      filterMembers: filter && community && community.members,
      fetchMore: () =>
        fetchMore({
          query: LoadMoreMembers,
          variables: {
            id: community.id,
            after:
              community.members.edges[community.members.edges.length - 1]
                .cursor,
            filter: filter || {},
            sort,
          },
          updateQuery: (prev, { fetchMoreResult }) => {
            if (!fetchMoreResult.community) {
              return prev;
            }

            return {
              ...prev,
              community: {
                ...prev.community,
                members: {
                  ...prev.community.members,
                  pageInfo: {
                    ...prev.community.members.pageInfo,
                    ...fetchMoreResult.community.members.pageInfo,
                  },
                  edges: [
                    ...prev.community.members.edges,
                    ...fetchMoreResult.community.members.edges,
                  ],
                },
              },
            };
          },
        }),
    },
  }),
  options: ({ id, filter, after, first = 200, sort }) => ({
    variables: {
      id,
      after: after || null,
      filter,
      first: (first || 200) < 200 ? 200 : first,
      sort,
    },
    fetchPolicy: 'network-only',
  }),
};

export default graphql(getcommunityMembersQuery, getcommunityMembersOptions);
